import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useSelector } from "react-redux";
import { markWithdrawal } from "../../../../../api/finalDelivery";

/**
 * Marca que un equipo no va a entregar. El motivo es opcional y queda a la
 * vista en la tabla. Desmarcar no pasa por acá: es un botón en la celda.
 */
const WithdrawalDialog = ({ open, team, onClose, onMarked }) => {
  const user = useSelector((state) => state.user);
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setReason("");
      setError(null);
    }
  }, [open]);

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      await markWithdrawal(user, team.id, reason.trim());
      onMarked?.(team.id, reason.trim() || null);
      onClose();
    } catch (e) {
      setError(e?.response?.data?.detail || "No se pudo guardar. Inténtalo de nuevo.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Equipo {team?.group_number}: no entrega</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          El equipo queda afuera del algoritmo de fechas de exposición, y su director y
          evaluadores no tienen que cargar disponibilidad por él. Se puede deshacer.
        </DialogContentText>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          label="Motivo (opcional)"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          fullWidth
          size="small"
          multiline
          minRows={2}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          color="warning"
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
        >
          Marcar que no entrega
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WithdrawalDialog;
